<template>
  <svg
    id="Layer_1"
    height="800px"
    width="800px"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xml:space="preserve"
  >
    <path
      style="fill:#F0F0F0;"
      d="M496.077,345.043C506.368,317.311,512,287.314,512,256s-5.632-61.309-15.923-89.043L256,144.696
	L15.923,166.957C5.633,194.691,0,224.686,0,256s5.633,61.311,15.923,89.043L256,367.304L496.077,345.043z"
    />
    <g>
      <path
        style="fill:#D80027;"
        d="M256,512c110.07,0,203.906-69.472,240.076-166.957H15.922C52.094,442.528,145.928,512,256,512z"
      />
      <path
        style="fill:#D80027;"
        d="M256,0C145.928,0,52.094,69.472,15.922,166.957h480.155C459.906,69.472,366.07,0,256,0z"
      />
    </g>
  </svg>
</template>
